import { Tooltip } from "@kamae-apps/shared/Components/Atoms/Tooltip/Tooltip"
import Icon from "@kamae-apps/shared/Components/Fondations/Icons/Icon"
import { IconNames } from "@kamae-apps/shared/Components/Fondations/Icons/IconNames.type"
import clsx from "clsx"
import { FC } from "react"
import { useNavigate } from "react-router-dom"
import { SidebarMode, useSidebarMode } from "../../../Contexts/SidebarMode/SidebarModeContext"

type MenuEntryProps = {
  content: string
  iconName: IconNames
  goTo: string
  isActive: boolean
  isDisabled: boolean
  tooltip: string
}

export const MenuEntry: FC<MenuEntryProps> = ({ content, iconName, goTo, isDisabled, isActive, tooltip }) => {
  const navigate = useNavigate()
  const { mode } = useSidebarMode()
  return (
    <button
      disabled={isDisabled}
      onClick={() => navigate(goTo)}
      data-testid={`nav-${goTo.replace(/^\//, "").split(/[/#]/)[0] || "home"}`}
      className={clsx(
        "h-13 flex items-center justify-between rounded-xl p-4 transition-all duration-300",
        mode === SidebarMode.EXPANDED ? "w-full" : "w-13",
        isActive && "bg-primary-kamae-50",
        isActive && mode !== SidebarMode.MOBILE && "bg-white",
        !isActive && !isDisabled && "bg-transparent hover:bg-white hover:bg-opacity-50"
      )}
      type={"button"}
    >
      <span
        className={clsx(
          "flex items-center gap-3",
          isActive && "text-primary-kamae-500",
          !isActive && isDisabled && "text-neutral-gray-400",
          !isActive && !isDisabled && "text-neutral-gray-600"
        )}
      >
        <Icon name={iconName} />
        {mode === SidebarMode.EXPANDED && (
          <Tooltip
            tooltipPosition={"tooltip-right"}
            title={tooltip}
            display={isDisabled}
          >
            <p
              className={clsx(
                isActive ? "caption-semibold" : "caption-regular",
                isDisabled ? "text-neutral-gray-400" : "text-neutral-gray-900"
              )}
            >
              {content}
            </p>
          </Tooltip>
        )}
      </span>
      {mode === SidebarMode.EXPANDED && (
        <span className={clsx("text-neutral-gray-600", isActive ? "opacity-100" : "opacity-0")}>
          <Icon name="chevronRight" />
        </span>
      )}
    </button>
  )
}
